import React from "react";
import "./PlainImage.css";

export default function PlainImage(props) {
  const { src, alt = "", height = "100vh", fit = "cover", position = "center", caption } = props || {};
  if (!src) return null;
  return (
    <section className="panel plain-image" style={{ height: "auto" }}>
      {caption && (
        <div
          className="plain-image__caption"
          dangerouslySetInnerHTML={{ __html: caption }}
        />
      )}
      <div style={{ height }}>
        <img
          className="plain-image__img"
          src={src}
          alt={alt}
          style={{ objectFit: fit, objectPosition: position }}
        />
      </div>
    </section>
  );
}